module.exports = __webpack_public_path__ + "img/ezp_green.a5498fd4.png";